import React from 'react'
import { Box } from 'src/ui'
import { Form, FormikProps } from 'formik'
import ConfigurationPanelFields from './ConfigurationPanelFields'

interface ConfigurationPanelFormProps {
  formikProps: FormikProps<any>
  formData: {
    submittedAt: number
    isSubmitting: boolean
  }
  formFields: { [key: string]: TenantConfiguration[] }
}

export default function ConfigurationPanelForm({
  formikProps,
  formData,
  formFields,
}: Readonly<ConfigurationPanelFormProps>) {
  const { submittedAt } = formData
  const { submitForm, values } = formikProps

  React.useEffect(() => {
    if (!submittedAt) return
    submitForm()
  }, [submittedAt, submitForm, values]) //values need to properly submit form

  return (
    <Box>
      <Form>
        <ConfigurationPanelFields formFields={formFields} />
      </Form>
    </Box>
  )
}
